module.exports = __webpack_public_path__ + "static/media/07.3b4b1152.jpg";